import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogActions from '@material-ui/core/DialogActions';
import moment from 'moment';

const Invoices = (props) => {
	const [invoices, setInvoices] = useState([]);
	const [loading, setLoading] = useState(true);

	// replaces component did mount
	useEffect(() => {
		async function fetchInvoices() {
			const res = await axios.get('/api/billing/invoices');

			const { data } = res;

			if (data.invoices) {
				setInvoices(data.invoices);
			}
			setLoading(false);
		}
		fetchInvoices();
	}, []);

	const closeButton = (
		<Button
			variant="text"
			color="primary"
			onClick={() => props.closeDialog(false)}
		>
			Close
		</Button>
	);

	const formatAmount = (amount) => {
		const str = amount.toString();
		const dollars = str.slice(0, -2);
		const cents = str.slice(-2);
		return `$${dollars}.${cents}`;
	};

	const invoiceTable = (
		<Paper>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Date</TableCell>
						<TableCell align="left">Amount</TableCell>
						<TableCell align="right">PDF</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{invoices.map((row) => (
						<TableRow key={row.created}>
							<TableCell component="th" scope="row">
								{moment(row.created * 1000).format(
									'MMMM DD, YYYY'
								)}
							</TableCell>
							<TableCell align="left">
								{formatAmount(row.amount)}{' '}
								{row.currency.toUpperCase()}
							</TableCell>
							<TableCell align="right">
								<a href={row.pdf}>Download</a>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Paper>
	);

	const spinner = <CircularProgress />;

	return (
		<div>
			{loading ? spinner : invoiceTable}
			<DialogActions>{closeButton}</DialogActions>
		</div>
	);
};

export default Invoices;



// WEBPACK FOOTER //
// ./src/components/settings/Invoices.js